// import image1 from "./assets/carouselImage1.jpg";
// import image2 from "./assets/carouselImage2.jpg";
// import image3 from "./assets/carouselImage3.jpg";
// import image4 from "./assets/carouselImage4.jpg";
// import image5 from "./assets/carouselImage5.jpg";
// import image6 from "./assets/carouselImage6.jpg";

import multicar1 from "../../assets/multicar1.png";
import multicar2 from "../../assets/multicar2.png";
import multicar3 from "../../assets/multicar3.png";
import multicar4 from "../../assets/multicar4.png";
import multicar5 from "../../assets/multicar5.png";
import multicar6 from "../../assets/multicar6.png";
import multicar7 from "../../assets/multicar7.png";
import multicar8 from "../../assets/multicar8.png";
import multicar9 from "../../assets/multicar9.png";
import multicar10 from "../../assets/multicar10.png";
import multicar11 from "../../assets/multicar11.png";
import multicar12 from "../../assets/multicar12.png";
import multicar13 from "../../assets/multicar13.png";



// export const data = [image1, image2, image3, image4, image5, image6];
export const multiData = [
  multicar1,
  multicar2,
  multicar3,
  multicar4,
  multicar5,
  multicar6,
  multicar7,
  multicar8,
  multicar9,
  multicar10,
  multicar11,
  multicar12,
  multicar13,
];
